<app-replay-game-controls-view
  [progressEvent]="progressEvent()"
  [totalSegments]="totalSegments()"
  [playIcon]="playIcon()"
  [playbackSpeed]="playbackSpeed()"
  (playClickedEvent)="onPlayClicked()"
  (skipBackClickedEvent)="onSkipBackClicked()"
  (skipForwardClickedEvent)="onSkipForwardClicked()"
  (playbackSpeedClickedEvent)="onPlaybackSpeedClicked()"
/>
